import React from 'react'
import '../styles/home.css'
import Homeslider from '../components/Homesilder1'
import Procard from '../components/cards/Procard'
import cm from '../img/cm.png'
import sell from '../img/sell.png'
import ser from '../img/service.png'


const home = () => {
    return (
        <div className='homemain'>
            <Homeslider />

            <div className='expmain'>
                <div className='head1'>OUR EXPERTISE</div>
                <br/>
                <div className='homecard_m'>

                    <Procard
                        imageSrc={cm}
                        title="customized machine"
                        altText="img of websit"            
                    />
                    <Procard
                        imageSrc={ser}
                        title="Machine maintanance & service"
                        altText="img of websit"
                     
                    />
                    {/* <Procard
                        imageSrc={sell}
                        title="sell"
                        altText="img of websit"
                        /> */}


                </div>
            </div>
        </div>
    )
}

export default home